import { CommandType } from "~app/common/services/cqs/CommandType";
import { ProduktionsmallProduktBaseCommand } from "./ProduktionsmallProduktBaseCommand";

export class AddProduktionsmallProduktCommand extends ProduktionsmallProduktBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddProduktionsmallProduktCommand";

    constructor(produktionsmallGuid: string, handelssortimentId: number, produktId: number) {
        super(AddProduktionsmallProduktCommand.$type, CommandType.Insert);
        this.produktionsmallGuid = produktionsmallGuid;
        this.handelssortimentId = handelssortimentId;
        this.produktId = produktId;
    }
}
